<!-- Payment prompts are intentionally disabled in this local build. -->
<template><div /></template>
